import "../App.css";
import { CONFIG } from "../config";
import inspirtai from "../logos/Inspirit_AI.webp";
import mec from "../logos/mec.webp";
import sciguide from "../logos/Sciguide.webp";
import algoverse from "../logos/algoverse.webp";
import sanes from "../logos/sanes.webp";
import whitecoat from "../logos/white_coat.webp";
import LazyLoad from "react-lazyload";
import nexttech from "../logos/NexTech.webp";
import endavor from "../logos/endeavor.webp";
import engineerlogo from "../logos/Engineering_Pivot_x_STEMed_Insights_LE_auto_x2.webp";
import stemlogo from "../logos/stemiverse_logo_no_bg.webp";
import medlogo from "../logos/MED-removebg-preview.webp";
import logotwo from "../logos/plogo.png";
import yri from "../logos/yri.png";
import logotwo1 from "../logos/halfglobe.png";
import punjabGroup from "../logos/punjab_group.png";
import stoodive from "../logos/stoodive.png";
import logotwo2 from "../logos/hypelogo.png";
import logotwo3 from "../logos/samyaklogo.png";
import logotwo5 from "../logos/ylogo.png";
import olpiamdhub from "../logos/perpolympiadhub.png";
import logofunny from "../logos/Fruit_logo.png";
import indigo from "../logos/indigo.png";
import biologo from "../logos/biologo.png";
import dialogo from "../logos/dialogogo.jpg";
import qlogo from "../logos/Qurios.jpg";
import googlelogo from "../logos/google.png";
import loomlogo from "../logos/newloom.png";
import desmos from "../logos/desmos.png";
import Typography from "@mui/material/Typography";
import "aos/dist/aos.css";

// Partner card component for consistent styling
const PartnerCard = ({
  onClick,
  logo,
  name,
  logoWidth = "45px",
  style = {},
}) => (
  <div
    onClick={onClick}
    style={{
      cursor: onClick ? "pointer" : "default",
      background: "#fff",
      borderRadius: "12px",
      padding: "24px 20px",
      boxShadow: "0 2px 12px rgba(0, 0, 0, 0.04)",
      border: "1px solid #e8eef3",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "120px",
      transition: "transform 0.2s ease, box-shadow 0.2s ease",
      ...style,
    }}
    onMouseEnter={(e) => {
      if (onClick) {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = "0 4px 20px rgba(0, 77, 153, 0.1)";
      }
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "0 2px 12px rgba(0, 0, 0, 0.04)";
    }}
  >
    <img
      width={logoWidth}
      className="no-invert-image-partners-css"
      src={logo}
      alt={name}
      style={{ marginBottom: "12px", objectFit: "contain" }}
    />
    <span
      style={{
        fontSize: "0.85rem",
        color: "#555",
        textAlign: "center",
        fontWeight: "500",
      }}
    >
      {name}
    </span>
  </div>
);

// Tier badge component
const TierBadge = ({ tier, color }) => (
  <div style={{ textAlign: "center", marginBottom: "30px" }}>
    <span
      style={{
        display: "inline-block",
        padding: "6px 20px",
        borderRadius: "20px",
        fontSize: "0.85rem",
        fontWeight: "600",
        textTransform: "uppercase",
        letterSpacing: "0.1em",
        background: `${color}15`,
        color: color,
        border: `1px solid ${color}30`,
      }}
    >
      {tier}
    </span>
  </div>
);

function Partners() {
  const punjabGroupClick = () => {
    window.location.href = "https://corporate.thetowertech.com/";
  };

  const InternationalMecClick = () => {
    window.location.href = "https://www.instagram.com/mec_competition/";
  };

  const indigologoClick = () => {
    window.location.href = "https://indigoresearch.org";
  };

  const QuriosClick = () => {
    window.location.href = "https://www.linkedin.com/company/qurios-institute/";
  };

  const PrepOlmpiadsClick = () => {
    window.location.href = "https://www.linkedin.com/company/prepolimpiadas/";
  };

  const GoogleClick = () => {
    window.location.href = "https://www.google.com/nonprofits/";
  };

  const YriClick = () => {
    window.location.href = "https://www.youthresearchinitiative.org/";
  };

  const InternationalBiologyBowlClick = () => {
    window.location.href = "https://biologybowl.org/";
  };

  const DesmosClick = () => {
    window.location.href = "https://www.desmos.com/";
  };

  return (
    <div style={{ padding: "80px 0", backgroundColor: "#f8f9fa" }}>
      <div className="container">
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "60px" }}>
          <h2
            style={{
              fontSize: "2.5rem",
              fontWeight: "600",
              color: "#1a1a2e",
              marginBottom: "16px",
              letterSpacing: "-0.02em",
            }}
          >
            Our Partners
          </h2>
          <p
            style={{
              fontSize: "1.05rem",
              color: "#555",
              maxWidth: "500px",
              margin: "0 auto",
            }}
          >
            IRO thanks the following organizations for their support.
          </p>
        </div>

        {/* Platinum Partners */}
        <TierBadge tier="Platinum" color="#6b7280" />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "24px",
            flexWrap: "wrap",
            marginBottom: "60px",
          }}
        >
          <PartnerCard
            onClick={indigologoClick}
            logo={indigo}
            name="Indigo Research"
            logoWidth="180px"
            style={{ minWidth: "260px", minHeight: "160px" }}
          />
          <PartnerCard
            onClick={punjabGroupClick}
            logo={punjabGroup}
            name="Punjab Group"
            logoWidth="150px"
            style={{ minWidth: "260px", minHeight: "160px" }}
          />
        </div>

        {/* Gold Partners */}
        <TierBadge tier="Gold" color="#ca8a04" />
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
            gap: "20px",
            maxWidth: "700px",
            margin: "0 auto 60px auto",
          }}
        >
          <PartnerCard
            onClick={QuriosClick}
            logo={qlogo}
            name="Qurios Institute"
            logoWidth="50px"
          />
          <PartnerCard
            onClick={PrepOlmpiadsClick}
            logo={logotwo}
            name="Prep Olimpíadas"
            logoWidth="45px"
          />
          <PartnerCard
            onClick={GoogleClick}
            logo={googlelogo}
            name="Google for Nonprofits"
            logoWidth="55px"
          />
        </div>

        {/* Silver Partners */}
        <TierBadge tier="Silver" color="#71717a" />
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
            gap: "20px",
            maxWidth: "900px",
            margin: "0 auto 60px auto",
          }}
        >
          <PartnerCard
            onClick={YriClick}
            logo={yri}
            name="Youth Research Initiative"
            logoWidth="50px"
            style={{ filter: "none" }}
          />
          <PartnerCard
            onClick={InternationalMecClick}
            logo={mec}
            name="MEC"
            logoWidth="50px"
          />
          <PartnerCard
            onClick={InternationalBiologyBowlClick}
            logo={biologo}
            name="International Biology Bowl"
            logoWidth="50px"
          />
          <PartnerCard
            onClick={DesmosClick}
            logo={desmos}
            name="Desmos"
            logoWidth="40px"
          />
        </div>

        {/* Bronze Partners */}
        <TierBadge tier="Bronze" color="#a16207" />
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))",
            gap: "16px",
            maxWidth: "1000px",
            margin: "0 auto 60px auto",
          }}
        >
          <PartnerCard
            logo={logotwo5}
            name="Youth Medical Journal"
            logoWidth="40px"
          />
          <PartnerCard
            logo={logotwo1}
            name="SySTEM for Success"
            logoWidth="40px"
          />
          <PartnerCard logo={logotwo2} name="HYPE 501(c)(3)" logoWidth="40px" />
          <PartnerCard
            logo={olpiamdhub}
            name="OlympiadPrepHub"
            logoWidth="40px"
          />
          <PartnerCard logo={logofunny} name="Pandorax" logoWidth="40px" />
          <PartnerCard logo={dialogo} name="Doism" logoWidth="40px" />
          <PartnerCard
            logo={engineerlogo}
            name="Engineering Pivot"
            logoWidth="40px"
          />
          <PartnerCard
            logo={stemlogo}
            name="STEMEd Insights"
            logoWidth="40px"
          />
          <PartnerCard logo={medlogo} name="Medmun Society" logoWidth="40px" />
          <PartnerCard logo={loomlogo} name="Everyone STEM" logoWidth="40px" />
          <PartnerCard
            logo={nexttech}
            name="Project NexTech"
            logoWidth="40px"
          />
          <PartnerCard logo={endavor} name="Endeavor" logoWidth="40px" />
          <PartnerCard logo={sciguide} name="SciGuide" logoWidth="40px" />
          <PartnerCard logo={whitecoat} name="White Coat" logoWidth="40px" />
          <PartnerCard logo={stoodive} name="Stoodive" logoWidth="40px" />
          <PartnerCard logo={sanes} name="Sanes" logoWidth="40px" />
        </div>

        {/* CTA */}
        <div
          style={{
            textAlign: "center",
            padding: "40px",
            background: "#fff",
            borderRadius: "16px",
            boxShadow: "0 2px 12px rgba(0, 0, 0, 0.04)",
            border: "1px solid #e8eef3",
            maxWidth: "600px",
            margin: "0 auto",
          }}
        >
          <p
            style={{
              fontSize: "1.1rem",
              color: "#1a1a2e",
              marginBottom: "8px",
              fontWeight: "500",
            }}
          >
            Interested in partnering with IRO?
          </p>
          <p style={{ fontSize: "0.95rem", color: "#555" }}>
            We are always looking to have new sponsors and partners join IRO!
            Please email us at{" "}
            <a
              style={{
                color: "#004d99",
                fontWeight: "600",
                textDecoration: "none",
              }}
              href={`mailto:${CONFIG.CONTACT_EMAIL}`}
            >
              {CONFIG.CONTACT_EMAIL}
            </a>{" "}
          </p>
        </div>
      </div>
    </div>
  );
}

export default Partners;
